import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab', 'error']
  static values = ['currentTab']

  toggleTabs (event) {
    const target = event.target.dataset.tabTarget;

    event.preventDefault();

    if (this.#canTransition()) {
      this.#transitionTo(target);
      this.errorTarget.classList.remove('d-block');
    } else {
      this.errorTarget.classList.add('d-block');
    }
  }

  #canTransition() {
    const currentTabElements = Array.from(this.element.querySelectorAll('input'));
    const isTabValid = currentTabElements.every((el) => el.checkValidity());

    return isTabValid;
  }

  #transitionTo(targetTab) {
    this.currentTabValue = targetTab;

    this.tabTargets.forEach((tab) => {
      if (tab.dataset.tabId === targetTab) {
        tab.classList.remove('d-none');
      } else {
        tab.classList.add('d-none');
      }
    });
  }
}
